export enum VoucherStatus {
  ACTIVE = 24001,
  USED = 24002,
  CANCELED = 24003,
  EXPIRED = 24004,
}

export enum VoucherType {
  SBSubscription = 23001,
  UpgradeToSmartLocker = 23002,
}
